import { createSelector } from 'reselect'

import { translateMain, translateAggregates } from '../../helpers'
import { REDUCER_NAME } from '../../store/constants'

export const getLKGrid = (state) => state[REDUCER_NAME]

export const getInstance = createSelector(
  [getLKGrid, (_state, instanceName) => instanceName],
  (lkGridInstance, instanceName) => lkGridInstance[instanceName],
)

export const getSelectedRow = (state, instanceName) => {
  const gridInstance = getInstance(state, instanceName)

  if (!gridInstance) {
    return null
  }

  return gridInstance.selectedRow
}

export const getIconColumns = (iColumnConfigs) => {
  if (iColumnConfigs == null) {
    return []
  }

  return Object.keys(iColumnConfigs).filter((columnName) => iColumnConfigs[columnName].iconComponent != null)
}

export const getLocaleText = () => ({
  excelExport: translateMain('lbl_exp_excel'),
  average: translateAggregates('pan_average_t'),
  count: translateAggregates('pan_count_t'),
  min: translateAggregates('pan_min_t'),
  max: translateAggregates('pan_max_t'),
  sum: translateAggregates('pan_sum_t'),
})

export const getDefaultSelected = (state, instanceName) => {
  const instance = getInstance(state, instanceName)
  return instance.defaultSelected
}
